import React from 'react';
import { tv } from 'tailwind-variants';
import Text from '@/components/ui/Text';
import useFlags from '@/hooks/useFlags';
import HeaderNumberBox from './Header/HeaderNumberBox';

type LessonSubheaderProps = {
  children: ReactChildren,
  description?: string,
  subheaderNumber?: number;
  title: string,
};

const wrapperStyles = tv({
  base: 'tw-relative tw-mb-8',
  variants: {
    reflow: {
      false: 'tw-ml-8',
      true: 'tw-ml-0',
    },
  },
});

const LessonSubheader = ({
  children,
  subheaderNumber,
  title,
}: LessonSubheaderProps) => {
  const { accessibilityReflow } = useFlags();
  if (!React.Children.count(children)) return null;

  return (
    <div className={wrapperStyles({ reflow: accessibilityReflow })}>
      <Text
        aria-label={title}
        className="tw-my-2 tw-align-middle"
        tag="h2"
        variant="heading3"
      >
        {subheaderNumber && (
          <HeaderNumberBox number={subheaderNumber} />
        )}
        <span className="tw-bg-white">{title}</span>
      </Text>
      <div className="tw-w-full">
        {children}
      </div>
    </div>
  );
};

export default LessonSubheader;
